"use client";

import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { usePathname } from "next/navigation";
import NewsletterSignup from 'src/components/newslettersignup/NewsletterSignup';
import FooterHeading from 'src/footer/FooterHeading';
import styles from './Newsletter.module.css';
import { locale } from "@locale";

//#region [Component]
export default function Newsletter() {
  const $ = _c(10);
  const pathname = usePathname();
  if (pathname === null) {
    return;
  }
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname.startsWith("/streamingguide");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isStreaming = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(styles.SNewsletter);
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = isStreaming ? "Meld deg p\xE5 Streamingguidens nyhetsbrev" : locale.newsletter.callToAction;
  let t3;
  if ($[3] !== t2) {
    t3 = <FooterHeading>{t2}</FooterHeading>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isStreaming) {
    t4 = <NewsletterSignup isStreaming={isStreaming} />;
    $[5] = isStreaming;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div className={t1}>{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
//#endregion